import defaultTheme from './clients/defaultTheme'

const Themes = {}
Themes.default = defaultTheme

export default Themes
